<script>
  import ItemPerPageSelectBox from "../../../components/select/ItemPerPageSelectBox.svelte";
  import { translate } from "../../../i18n/i18next.js";
  import MenuBar from "../../../components/menuBar/MenuBar.svelte";
  import MenuBarItem from "../../../components/menuBar/MenuBarItem.svelte";
  import PageSelector2 from "../../../components/layout/PageSelector2.svelte";
  import GeneralSelect from "../../../components/select/GeneralSelect.svelte";
  import { saveOrderTableConfiguration } from "./OrderTableConfigurationStorage.js";
  import { applySearchParam } from "../../../utils/searchParams/applySearchParam.js";

  /**
   * Index of currently selected style
   * @type {number | null}
   */
  export let styleIndex;

  /**
   * Available styles
   * @type {{
   *   name: string | null,
   *   index: number | null,
   * }[]}
   */
  export let styles;

  /**
   * Number of items per page
   * @type {number | null}
   */
  export let itemPerPage;

  /**
   * Total number of pages
   * @type {number | null}
   */
  export let totalPageNumber = 1;

  /**
   * Current index of the page
   */
  export let currentIndex = 0;

  /**
   * @type {string|undefined}
   */
  export let userId

  /**
   * @type {string}
   */
  export let projectId

  function onChangeSettings(settingName, newValue) {
    if (!userId || !projectId) return
    saveOrderTableConfiguration({[settingName]: newValue}, userId, projectId)

    if (settingName === "styleName") {
      applySearchParam("style", newValue);
    }
  }
</script>

<MenuBar>
  <svelte:fragment slot="settings">
    <MenuBarItem>
      <svelte:fragment slot="label">{translate("asprova.terms.style")}</svelte:fragment>
      <GeneralSelect
        bind:value={styleIndex}
        onChangeEvent={e => {
            onChangeSettings("styleName", styles[parseInt(e.target.value, 10)-1].name)
          }}
        options={styles.map((style) => ({text: style.name, value: style.index}))}
      />
    </MenuBarItem>
    <MenuBarItem>
      <svelte:fragment slot="label">{translate("frontend:generic.itemsPerPage")}</svelte:fragment>
      <ItemPerPageSelectBox
        bind:value={itemPerPage}
        onChange={e => {onChangeSettings("itemPerPage", parseInt(e.target.value, 10))}}
      />
    </MenuBarItem>
  </svelte:fragment>
  <MenuBarItem slot="pagination">
    <PageSelector2 totalPageNumber={totalPageNumber} bind:currentIndex={currentIndex} />
  </MenuBarItem>
</MenuBar>
